package org.example.site_web.components.images

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.dom.svg.Circle
import com.varabyte.kobweb.compose.dom.svg.Defs
import com.varabyte.kobweb.compose.dom.svg.Line
import com.varabyte.kobweb.compose.dom.svg.LinearGradient
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.RadialGradient
import com.varabyte.kobweb.compose.dom.svg.Rect
import com.varabyte.kobweb.compose.dom.svg.SVGFillRule
import com.varabyte.kobweb.compose.dom.svg.SVGStrokeLineCap
import com.varabyte.kobweb.compose.dom.svg.Stop
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.dom.svg.SvgId
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import org.example.site_web.aiPalette
import org.example.site_web.components.images.Mask
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val agradient = SvgId("agradient")
val armgradient = SvgId("armgradient")


@Composable
fun GlobalSvg() {
    val offset = 100 - 50
    Svg(Modifier.width(0.px).height(0.px).toAttrs {
        viewBox(0, 0, 64, 64)
    }) {
        val agradient = SvgId("agradient")
        val argradient = SvgId("argradient")
        val armgradient = SvgId("armgradient")
        Defs() {
            LinearGradient(
                id = argradient,
                Modifier.toAttrs {
                    attr("gradientTransform", "rotate(90)")
                }) {
                Stop((0).percent, aiPalette.mainPalette.primary)
                Stop((100).percent, aiPalette.mainPalette.darkest)
            }

            RadialGradient(id = armgradient) {
                Stop((0).percent, aiPalette.mainPalette.primary)
                //Stop((100-offset.value).percent, aiPalette.mainPalette.primary)
                Stop((100 - offset).percent, aiPalette.mainPalette.darkest)
                Stop((100).percent, aiPalette.mainPalette.darkest)
            }
        }

        Mask(Modifier.toAttrs {
            id("bulbmask")
        }) {
            Path {
                d("M33,49H23l0.609,4.261c0.235,1.648,1.467,2.978,3.092,3.339L33,58V49z")
                fillRule(SVGFillRule.EvenOdd)
                fill(Colors.White)
            }
            Path {
                d("M31,46h-3c0-8.611-1.687-14.515-2.814-17.5c-0.504-1.335,0.021-2.836,1.261-3.542l0.356-0.203C26.974,25.056,31,32.26,31,46z")
                fillRule(SVGFillRule.EvenOdd)
                fill(Colors.White)
            }
            Rect {
                x(2)
                y(23)
                width(5)
                height(3)
                fill(Colors.White)
            }
            Rect {
                x(8.5)
                y(6.625)
                transform { matrix(0.6148, -0.7887, 0.7887, 0.6148, -3.6405, 11.5465) }
                width(3)
                height(5.75)
                fill(Colors.White)
            }
            Rect {
                x(7.125)
                y(37)
                transform { matrix(0.7888, -0.6146, 0.6146, 0.7888, -21.5517, 14.2773) }
                width(5.75)
                height(3)
                fill(Colors.White)
            }
            Path {
                fill(Colors.White)
                d("M31,49h10l-0.609,4.261c-0.235,1.648-1.467,2.978-3.092,3.339L31,58V49z")
            }

            Path {
                d(
                    "M40.31,46H39c0-2.901,1.783-5.688,3.849-8.917c3.199-4.999,6.963-10.881,4.181-18.236c" +
                            "-2.433-6.432-8.37-10.938-15.246-10.847C23.06,8.118,16,15.25,16,24c0,5.033,2.736,9.31,5.151,13.083" +
                            "C23.217,40.312,25,43.099,25,46h-1.31c-0.904,0-1.67-0.61-1.926-1.477c-0.503-1.703-1.749-3.649-3.14-5.823" +
                            "c-3.237-5.059-7.496-11.716-4.735-20.141c2.61-7.965,9.96-13.659,18.342-13.559C42.601,5.125,51,13.6,51,24" +
                            "c0,5.911-3.118,10.785-5.624,14.701c-1.391,2.174-2.636,4.12-3.14,5.823C41.98,45.39,41.214,46,40.31,46z"
                )
                fill(Colors.White)
            }
            Path {
                fillRule(SVGFillRule.EvenOdd)
                fill(Colors.White)
                d("M28,56c0,2.209,1.791,4,4,4s4-1.791,4-4H28z)}")
            }
            Path {
                d("M36,46h-3c0-13.74,4.026-20.944,4.197-21.244l0.359,0.205c1.237,0.707,1.761,2.206,1.257,3.539C37.687,31.483,36,37.388,36,46z")
                fill(Colors.White)
            }
            Rect {
                x(57)
                y(23)
                width(5)
                height(3)
                fill(Colors.White)
            }
            Rect {
                x(51.125)
                y(8)
                width(5.75)
                height(3)
                transform { matrix(0.7888, -0.6146, 0.6146, 0.7888, 5.5653, 35.1968) }
                fill(Colors.White)
            }
            Rect {
                x(52.5)
                y(35.625)
                width(3)
                height(5.75)
                transform { matrix(0.6148, -0.7887, 0.7887, 0.6148, -9.5632, 57.4201) }
                fill(Colors.White)
            }
        }

        val strokeW = 4
        Mask(Modifier.toAttrs {
            id("three-arrows-mask")
        }) {
            Line {
                x1(32)
                y1(60)
                x2(32)
                y2(6)
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
            Line {
                x1(32)
                y1(6)
                x2(22)
                y2(16)
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
            Line {
                x1(32)
                y1(6)
                x2(42)
                y2(16)
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
            //******************************************
            Path {
                d("M 42 32 A 10 10 0 0 0 32 42")
                //fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }

            Line {
                x1(42)
                y1(32)
                x2(60)
                y2(32)
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
            Line {
                x1(60)
                y1(32)
                x2(50)
                y2(22)
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
            Line {
                x1(60)
                y1(32)
                x2(50)
                y2(42)
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
            // }
            Path {
                d("M 22 32 A 10 10 0 0 1 32 42")
                //fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }

            Line {
                x1(22)
                y1(32)
                x2(4)
                y2(32)
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeLineCap(SVGStrokeLineCap.Round)

                strokeWidth(strokeW)
            }

            Line {
                x1(4)
                y1(32)
                x2(14)
                y2(22)
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
            Line {
                x1(4)
                y1(32)
                x2(14)
                y2(42)
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
        }

        Mask(Modifier.toAttrs {
            id("mag-glass-mask")
        }) {
            val cq = 22
            val radius = 19
            val lmanche = 28
            val emanche = 10

            Circle {
                cx(cq)
                cy(cq)
                r(radius)
                //fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }

            Circle {
                cx(cq)
                cy(cq)
                r(radius-6)
                //fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }

            Path {
                d("M 0 0 A $radius $radius 0 0 1 0 $emanche L $lmanche $emanche A $radius $radius 0 0 0  $lmanche 0 L 0 0")
                //fillRule(SVGFillRule.EvenOdd)
                transform{
                    rotate(45)
                    translate(3*radius-emanche/2.0,-emanche/2.0)
                }
                fillRule(SVGFillRule.EvenOdd)
                fill(Colors.White)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
        }

                Mask(Modifier.toAttrs {
            id("wrench-mask")
        }) {

            Path {
                d("m 45.683565,1.0181802 c -3.421373,0.5940859 -6.34818,2.6546172 -8.69985,6.1246799 -1.194052,1.7605771 -1.799637,3.9941559 -1.799637,6.6383499 0,2.169273 0.412648,4.101087 0.689701,5.153992 -4.573614,4.006382 -31.416562,27.528591 -32.3679133,28.470826 -1.7250529,1.708507 -2.67457323,3.979015 -2.67457323,6.393382 0,4.992144 4.08890953,9.042303 9.12974183,9.042303 2.4376267,0 4.7301157,-0.940414 6.4551687,-2.648921 C 19.312446,57.324324 42.14164,31.553403 45.368246,27.908365 L 57.22037,26.841287 55.70353,24.671045 c 2.428085,-1.102195 3.98319,-2.950687 4.955573,-4.638366 1.683126,-2.920422 1.960062,-5.913734 1.971552,-6.039555 l 0.200637,-2.297866 -9.185251,4.548398 -3.834032,-9.69e-4 -1.885585,-2.699054 0.24832,-2.208992 9.899657,-6.5362724 -1.505341,-1.091665 C 56.360711,3.5554624 51.412723,0.02291549 45.683565,1.0181802 Z M 51.619106,18.82646 c 3.003193,0.401731 0,0 0,0 z")
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }
            Path {
                d("m 12.856468,50.631978 c -0.76307,-0.75588 -1.77679,-1.17188 -2.85551,-1.17188 -1.0787195,0 -2.0943295,0.416 -2.8555095,1.17188 -0.76319,0.75587 -1.18322,1.75975 -1.18322,2.82812 0,1.06838 0.42003,2.07425 1.18322,2.82813 1.57372,1.56049 4.1372995,1.56049 5.7110195,0 0.76319,-0.75388 1.18322,-1.75975 1.18322,-2.82813 0,-1.06837 -0.42003,-2.07225 -1.18322,-2.82812 z"
                )
                fillRule(SVGFillRule.EvenOdd)
                stroke(Colors.White)
                strokeWidth(strokeW)
                strokeLineCap(SVGStrokeLineCap.Round)
            }

        }
    }
}